import { Avatar, Checkbox } from '@mantine/core';
import classnames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useFetchChecklistSubmission from 'src/Hooks/Queries/useFetchChecklistSubmission';

import styles from './ChecklistSubmissionDetails.module.scss';
import { Props } from './ChecklistSubmissionDetails.types';

const ChecklistSubmissionDetails = ({ checklistSubmissionId }: Props) => {
  const { data: submission } = useFetchChecklistSubmission(checklistSubmissionId);
  const { t } = useTranslation();

  const getInitials = useCallback((user?: { firstName: string; lastName: string }) => {
    if (!user) return '';
    return (user.firstName.charAt(0) + user.lastName.charAt(0)).toUpperCase();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.topRow}>
        <div className={styles.name}>
          <Avatar color="initials" radius="xl">
            {submission?.submittedBy?.firstName &&
              submission?.submittedBy?.lastName &&
              getInitials(submission?.submittedBy ?? undefined)}
          </Avatar>
          {submission?.submittedBy?.firstName || submission?.submittedBy?.lastName
            ? [submission?.submittedBy?.firstName, submission?.submittedBy?.lastName].join(' ')
            : t('checklist.invitedUser', 'Invité')}
        </div>
        <div
          className={styles.date}
        >{`${submission?.submittedAt.format('L')} ${submission?.submittedAt.format('LT')}`}</div>
      </div>
      {submission?.items.map(item => (
        <div
          className={classnames(styles.optionRow, {
            [styles.optionRowSelected]: item.isChecked,
          })}
          key={item.checklistItemId}
        >
          <div className={styles.checkboxWrapper}>
            <Checkbox
              disabled
              className={styles.checkbox}
              classNames={{
                label: styles.checkboxLabel,
                root: styles.checkboxRoot,
                labelWrapper: styles.labelWrapper,
              }}
              checked={item.isChecked}
              label={item.label}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChecklistSubmissionDetails;
